(function () {
  function fix() {
    var box = document.querySelector('.productView-title .ddreview-star');
    if (!box || box.getAttribute('data-page') !== 'product') {
      return false;
    }
    var count = box.querySelector('.dd-review-count');
    if (!count) {
      return false;
    }
    if (count.getAttribute('data-dd-count-fixed') === '1') {
      return true;
    }
    var text = (count.textContent || '').trim();
    var match = text.match(/^\((\d+)\)$/);
    if (match) {
      count.textContent = match[1] + ' reviews';
      count.setAttribute('data-dd-count-fixed', '1');
      return true;
    }
    return true;
  }

  function start() {
    if (document.body && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        fix();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      fix();
      if (tries > 80) {
        clearInterval(timer);
      }
    }, 250);
    fix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
